var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 23,
    viewBox: "0 0 55 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1395",
    "data-name": "Raggruppa 1395",
    transform: "translate(2768 -736.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_700",
    "data-name": "Rettangolo 700",
    width: 55,
    height: 23,
    rx: 4,
    transform: "translate(-2768 736.5)",
    fill: "rgba(50,125,201,0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1889",
    "data-name": "Tracciato 1889",
    d: "M2.31-1.294H5.731V0H.7V-7.82H2.31ZM8.125,0H6.567V-5.812H8.125ZM6.476-7.315A.764.764,0,0,1,6.71-7.89a.878.878,0,0,1,.636-.226.88.88,0,0,1,.634.226.76.76,0,0,1,.236.575.762.762,0,0,1-.239.58.882.882,0,0,1-.631.226.882.882,0,0,1-.631-.226A.762.762,0,0,1,6.476-7.315Zm4.29,1.5.048.671a2.029,2.029,0,0,1,1.67-.779,1.686,1.686,0,0,1,1.375.542,2.531,2.531,0,0,1,.462,1.622V0H12.769V-3.717a1.007,1.007,0,0,0-.215-.717.962.962,0,0,0-.714-.223,1.068,1.068,0,0,0-.983.559V0H9.305V-5.812Zm6.777,3.48-.559.559V0H15.432V-8.25h1.552v4.571l.3-.387,1.488-1.746h1.864l-2.1,2.422L20.819,0H19.036ZM23.917.107a2.853,2.853,0,0,1-2.081-.784,2.787,2.787,0,0,1-.8-2.089v-.15a3.511,3.511,0,0,1,.338-1.566,2.483,2.483,0,0,1,.959-1.063,2.691,2.691,0,0,1,1.415-.373,2.412,2.412,0,0,1,1.877.752,3.056,3.056,0,0,1,.685,2.132V-2.4h-3.7a1.442,1.442,0,0,0,.454.913,1.372,1.372,0,0,0,.959.344,1.675,1.675,0,0,0,1.4-.65l.763.854a2.33,2.33,0,0,1-.945.771A3.1,3.1,0,0,1,23.917.107Zm-.177-4.77a.972.972,0,0,0-.749.312,1.609,1.609,0,0,0-.368.892h2.159v-.124a1.147,1.147,0,0,0-.279-.8A1,1,0,0,0,23.739-4.662ZM26.88-2.949a3.5,3.5,0,0,1,.61-2.165,1.978,1.978,0,0,1,1.668-.806,1.78,1.78,0,0,1,1.4.634V-8.25h1.558V0h-1.4L30.64-.618a1.827,1.827,0,0,1-1.493.725A1.973,1.973,0,0,1,27.5-.7,3.615,3.615,0,0,1,26.88-2.949Zm1.552.113a2.288,2.288,0,0,0,.285,1.251.928.928,0,0,0,.827.435,1.039,1.039,0,0,0,1.015-.607V-4.05a1.024,1.024,0,0,0-1-.607Q28.432-4.657,28.432-2.836ZM35.069,0H33.458V-7.82h1.611Zm2.754-5.812.048.671a2.029,2.029,0,0,1,1.67-.779,1.686,1.686,0,0,1,1.375.542,2.531,2.531,0,0,1,.462,1.622V0H39.827V-3.717a1.007,1.007,0,0,0-.215-.717.962.962,0,0,0-.714-.223,1.068,1.068,0,0,0-.983.559V0H36.362V-5.812Z",
    transform: "translate(-2761 752.207)",
    fill: "#0b66c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOpacity);
export default __webpack_public_path__ + "static/media/linkedin-opacity.3027ea6f37e4fb22a70d8e71a611098c.svg";
export { ForwardRef as ReactComponent };